module.exports = __webpack_public_path__ + "static/media/confirmation.02a82e72.svg";